exports.install = function (Vue, options) {
  Vue.prototype.formattScheduleTable = function (arr) {
    let newArr = [];
    arr.map((i) => {
      let n = this.dataTrans(i.cells);
      // console.log(n);
      n.id = i.objId;
      n.classId = i.objClass;
      n.subclassId = i.objSubClass;
      n.parentId = i.parentRowId;
      // n.statusId = i.statusId
      n.isLeaf = i.isLeaf;
      n.createdBy = i.createdBy;
      n.projectNumber = i.projectNumber;
      n.statusType = i.statusType;
      n.specialState = i.specialState;
      newArr.push(n);
      if (i.children != null) {
        n.children = this.formattScheduleTable(i.children);
      } else {
        n.children = [];
      }
    });
    return newArr;
  };
  Vue.prototype.dataTrans = function (arr) {
    // console.log(arr);
    let list = this.scheduleList;
    let n = {};
    // console.log(arr);
    for (let i = 0; i < arr.length; i++) {
      let j = arr[i] || { val: "", id: "", ids: "", editable: false },
        e = list[i];
      // console.log(j);
      if (e.uiType == 3) {
        if (e.field == "1054069") {
          j = !j ? { val: "" } : j;
          Object.assign(n, { [e.field]: j.val });
        }
        // if (e.field == "1054052") {
        //   j.id = j.id == -1 ? "" : j.id;
        //   // console.log({[e.editRender.options] : [{label:j.val,value:j.id}]});
        //   // e.editRender = {}
        //   Object.assign(n, { [e.parentId] : j.id,[e.field]: j.val});
        //   // console.log(n);
        // }
        else {
          const m = j.id == -1 ? "" : j.id;
          Object.assign(n, { [e.field]: m });
        }
        // console.log(n);
      }
      if (e.uiType == 4) {
        const m = j.ids == "" ? [] : j.ids.split(";");
        Object.assign(n, { [e.field]: m });
      }
      if (e.uiType == 6) {
        const m = j.date == null ? "" : new Date(j.date);
        // console.log(m);
        Object.assign(n, { [e.field]: m });
      }
      if ([1, 7, 10].includes(e.uiType)) {
        if (e.field == "1054008") {
          // console.log(j);
          const m = !j.val ? [] : j.val.split(";");
          // console.log(m);
          Object.assign(n, { [e.field]: m });
        } else {
          if (e.field == "1054007") {
            n.statusId = j.id;
          }
          // j = !j ? { val: "" } : j;
          const val = j ?? { val: "" };
          Object.assign(n, { [e.field]: val.val });
        }
      }
    }
    // console.log(n);
    return n;
  };
  Vue.prototype.getProName = function (arr, newArr) {
    newArr = newArr || [];
    for (let i = 0; i < arr.length; i++) {
      const item = arr[i];
      if (item["id"]) {
        newArr.push({ label: item["1054001"], value: item.id });
        if (item["children"]) {
          this.getProName(item["children"], newArr);
        }
      }
    }
    return newArr;
  };

  Vue.prototype.findAttr = function (n) {
    let m = this.scheduleList.find((i) => i.field == n) || { editRender: {} };
    return m;
  };

  Vue.prototype.addChildren = function ({ arr, value, item }) {
    // console.log({ arr, value, item });
    let newArr = [];
    arr.forEach((e) => {
      if (e._XID === value) {
        if (!e.children) {
          e.children = [];
        }
        e.children.push(item);
        newArr.push(e);
      } else {
        // console.log(e);
        if (e.children) {
          e.children = this.addChildren({
            arr: e.children,
            value,
            item,
          });
          newArr.push(e);
        } else {
          newArr.push(e);
        }
      }
    });
    return newArr;
  };

  //提交数据时data格式化
  Vue.prototype.formatData = function (row) {
    row["1054009"] = new Date(Date.parse(row["1054009"]));
    row["1054010"] = new Date(Date.parse(row["1054010"]));
    let item = this.deepClone(row);

    item.subclassId = parseInt(item["1054006"]);

    if (row["1054008"] != undefined) {
      item["1054008"] = !row["1054008"].length ? "" : row["1054008"].join(";");
    }

    let arrData = this.scheduleList
      .filter((i) => i.uiType == 4)
      .map((j) => j.field);

    for (let i = 0; i < arrData.length; i++) {
      const e = arrData[i];
      if (Array.isArray(item[e])) {
        item[e] = !item[e].length ? "" : item[e].join(";");
      }
    }

    item["1054057"] = "";
    item["1054065"] = "";

    this.currencyList.map((i) => {
      item[i] = parseFloat(item[i]);
    });

    let arr = [
      "_XID",
      "value",
      "label",
      "children",
      "createdBy",
      "parentXId",
      "statusId",
      "seq",
      "1054069",
      "1054071",
      "1054012",
      "1054013",
      "1054014",
      "1054016",
      "1054018",
      "1054019",
      "1054051",
      "1054052",
      "1054007",
    ];

    arr.map((i) => {
      delete item[i];
    });

    item["rootId"] = item.id == this.rootId ? 0 : this.rootId;
    console.log(item);
    return item;
  };

  Vue.prototype.subDataFormat = function (row) {
    console.log(Object.keys(row), row);
    // let arrData = this.scheduleList.filter(i => i.uiType == 4).map(j =>j.field);
    let newItem = {};

    for (const key in row) {
      if (Object.prototype.hasOwnProperty.call(row, key)) {
        const el = row[key];
        if (!["seq", "_XID", "_X_ROW_KEY"].includes(key)) {
          newItem[key] = el;
        }

        if (this.currencyList.includes(key)) {
          newItem[key] = parseFloat(el);
        }
        // if (arrData.includes(key) && Array.isArray(el)) {
        if (Array.isArray(el)) {
          newItem[key] = !el.length ? "" : el.join(";");
        }
        if (["1054009", "1054010"].includes(key)) {
          newItem[key] = new Date(Date.parse(el)) || "";
        }
      }
    }

    if (row.id) {
      let item = this.getRow(this.tableData, row.id)[0];
      newItem["parentId"] = item.parentId;
      newItem["isLeaf"] = item.isLeaf;
    }
    if (!row.id) {
      // delete row["_XID"];
      // delete row["_X_ROW_KEY"];
      newItem["displayOrder"] = row["displayOrder"] || row.seq;
      // delete row.seq;
    }
    newItem["rootId"] = row.id == this.rootId ? 0 : this.rootId;
    newItem["subclassId"] = row["1054006"]
      ? Number(row["1054006"])
      : row["subclassId"];
    console.log(newItem);

    return newItem;
  };

  // Vue.prototype.subDataFormat = function (row) {
  //   console.log(Object.keys(row), row);
  //   // let arrData = this.scheduleList.filter(i => i.uiType == 4).map(j =>j.field);
  //   Object.keys(row).map((i) => {
  //     if (this.currencyList.includes(i)) {
  //       row[i] = parseFloat(row[i]);
  //     }
  //     // if (arrData.includes(i) && Array.isArray(row[i])) {
  //     if (Array.isArray(row[i])) {
  //       row[i] = !row[i].length ? "" : row[i].join(";");
  //     }
  //     if (["1054009", "1054010"].includes(i)) {
  //       row[i] = new Date(Date.parse(row[i])) || "";
  //     }
  //     if (i == "1054006") {
  //       row.subclassId = parseInt(row["1054006"]);
  //     }

  //     // if (["1054008"].includes(i)) {
  //     //   // row[i] = row[i.split]
  //     //   // const arr = row[i].split(";");
  //     //   // console.log(arr);
  //     //   // const n = arr.map((j) => {
  //     //   //   j = j + "_1";
  //     //   //   return j;
  //     //   // });
  //     //   // row[i] = n.join(";");
  //     //   // row["1054009"] = this.getRow(this.tableData, row.id)[0]["1054009"];
  //     // }
  //   });
  //   if (row.id) {
  //     let item = this.getRow(this.tableData, row.id)[0];
  //     row["parentId"] = item.parentId;
  //     row["isLeaf"] = item.isLeaf;
  //   }
  //   if (!row.id) {
  //     delete row["_XID"];
  //     delete row["_X_ROW_KEY"];
  //     row["displayOrder"] = row["displayOrder"] || row.seq;
  //     delete row.seq;
  //   }
  //   row["rootId"] = row.id == this.rootId ? 0 : this.rootId;
  //   console.log(row);

  //   return row;
  // };

  Vue.prototype.getListLabel = (list) => {
    const fun = (list) => {
      const arr = list.map((i) => {
        const n = {
          value: i.id + "_1",
          label: i["1054001"],
          seq: i.seq,
        };

        if (i.children?.length) {
          n.children = fun(i.children);
        }
        return n;
      });
      return arr;
    };
    return fun(list);
  };

  // Vue.prototype.changTime = function(list, id, t) {
  //   // const id = id,list = list,t =t;
  //   let timeChange = (list, id, t) => {
  //     list.map((i) => {
  //       if (i.id == id) {
  //         let baseRow = this.getRow(this.baseData,id)[0]
  //         if (Date.parse(baseRow["1054009"]) > Date.parse(t)) {
  //           i["1054009"] = t;
  //           // this.changeData.push(i);
  //         } else{
  //           i["1054009"] = baseRow["1054009"]
  //         }
  //       } else {
  //         if (i.children) {
  //           timeChange(i.children, id, t);
  //         }
  //       }
  //     });
  //   };
  //   return timeChange(list, id, t);
  // };
  // Vue.prototype.changTime2 = function(list, id, t) {
  //   // const id = id,list = list,t =t;
  //   let timeChange = (list, id, t) => {
  //     list.map((i) => {
  //       if (i.id == id) {
  //         let baseRow = this.getRow(this.baseData,id)[0]
  //         if (Date.parse(baseRow["1054010"]) < Date.parse(t)) {
  //           i["1054010"] = t;
  //           // this.changeData.push(i);
  //         }else{
  //           i["1054010"] = baseRow["1054010"]
  //         }
  //       } else {
  //         if (i.children) {
  //           timeChange(i.children, id, t);
  //         }
  //       }
  //     });
  //   };
  //   return timeChange(list, id, t);
  // };

  Vue.prototype.getColumn = function () {
    // console.log(this.scheduleList);
    this.gridOptions.columns = [
      ...this.gridOptions.columns,
      ...this.scheduleList,
    ];
  };
  Vue.prototype.updateTableState = function (stateId) {
    this.tableLoading = true;
    let stateVal = {
      projectId: this.changeTableCellObjId,
      targetStatusId: stateId,
    };
    this.$http
      .post("/ppm/project/changeProjectStatus", stateVal)
      .then((res) => {
        console.log(res);
        if (res.data.code == 200) {
          this.$message({
            message: res.data.message,
            type: "success",
          });
          this.getScheduleInfo();
          // this.loadTableStates(this.changeTableCellObjId);
          const { id, classId, subClassId } = this.$route.query;
          const obj = { id, classId, subClassId };
          this.$store.dispatch("projectWorkflow/getWorkFlowStatus", obj);
          this.$store.dispatch("projectWorkflow/queryTaskStatus", obj);
        }
      })
      .finally(() => {
        this.tableLoading = false;
      });
  };
  Vue.prototype.getExportData = function (isHead) {
    this.getExportedBOM(this.gridOptions.data, "");
    let datas = this.exportedBom;
    // console.log(datas);
    this.exportedBom = [];
    let columns = this.gridOptions.columns;
    let headers = isHead ? [columns.map((item) => item.title)] : [];
    return headers.concat(
      datas.map((row) => {
        return columns.map((column) => {
          return row[column.field];
        });
      })
    );
  };
  Vue.prototype.getExportedBOM = function (bom, level) {
    // console.log("getExportedBOM");
    // console.log(bom);
    for (var i = 0; i < bom.length; i++) {
      let newBom = this.deepClone(bom[i]);
      newBom[0] = level + newBom[0];
      this.exportedBom.push(newBom);
      if (bom[i].children != null) {
        this.getExportedBOM(bom[i].children, level + "|");
      }
    }
  };
  Vue.prototype.toBuffer = function (wbout) {
    let buf = new ArrayBuffer(wbout.length);
    let view = new Uint8Array(buf);
    for (let index = 0; index !== wbout.length; ++index)
      view[index] = wbout.charCodeAt(index) & 0xff;
    return buf;
  };
  Vue.prototype.validNewArr = function (arr) {
    let n = [];
    arr.map((i) => {
      console.log(i);
      let parentRow = this.getRow(this.gridOptions.data, i.parentId)[0];
      console.log(parentRow);
      let list = parentRow.children.map((i) => i.classId);
      !list.includes(30101) && n.push(i);
    });
    return n;
  };

  Vue.prototype.countEndDate = function (n, sDay) {
    //  console.log(w,r);

    if (!n || !sDay) {
      return "";
    }
    const templist = this.calendarList;
    const n1 = templist
      .filter((i) => i.exceptionType == 1)
      .map((i) => i.exceptionDate.split("T")[0]);
    const n2 = templist
      .filter((i) => i.exceptionType == 2)
      .map((i) => i.exceptionDate.split("T")[0]);
    // console.log(n1,n2);
    // const s = ![0,6].includes(sDay.getDay()) ? Date.parse(sDay) : !sDay.getDay()? Date.parse(sDay) + 24*60*60*1000 : Date.parse(sDay) + 2*24*60*60*1000
    // let e = s;
    let e = Date.parse(sDay);

    // let m = n1.includes(this.getLocalTime(e)) || ([0,6].includes(new Date(e).getDay()) && !n2.includes(this.getLocalTime(e)));
    while (
      n1.includes(this.getLocalTime(e)) ||
      ([0, 6].includes(new Date(e).getDay()) &&
        !n2.includes(this.getLocalTime(e)))
    ) {
      e += 24 * 60 * 60 * 1000;
    }
    console.log(e);

    for (let i = 0; i < n - 1; i++) {
      do {
        e += 24 * 60 * 60 * 1000;
      } while (
        n1.includes(this.getLocalTime(e)) ||
        ([0, 6].includes(new Date(e).getDay()) &&
          !n2.includes(this.getLocalTime(e)))
      );

      // console.log(e,this.getLocalTime(e));
    }
    let eDay = new Date(e);
    return eDay;
  };

  Vue.prototype.countStartDate = function (n, eDay) {
    if (!n || !eDay) {
      return "";
    }
    const templist = this.calendarList;
    const n1 = templist
      .filter((i) => i.exceptionType == 1)
      .map((i) => i.exceptionDate.split("T")[0]);
    const n2 = templist
      .filter((i) => i.exceptionType == 2)
      .map((i) => i.exceptionDate.split("T")[0]);
    let s = Date.parse(eDay);

    while (
      n1.includes(this.getLocalTime(s)) ||
      ([0, 6].includes(new Date(s).getDay()) &&
        !n2.includes(this.getLocalTime(s)))
    ) {
      s -= 24 * 60 * 60 * 1000;
    }
    // console.log(s);

    for (let i = 0; i < n - 1; i++) {
      do {
        s -= 24 * 60 * 60 * 1000;
      } while (
        n1.includes(this.getLocalTime(s)) ||
        ([0, 6].includes(new Date(s).getDay()) &&
          !n2.includes(this.getLocalTime(s)))
      );
    }
    let sDay = new Date(s);
    return sDay;
  };

  (Vue.prototype.countWorkDay = function (sDay, eDay) {
    if (!sDay || !eDay) {
      return "";
    }

    sDay = new Date(sDay);
    eDay = new Date(eDay);

    const templ = this.calendarList;
    const n1 = templ
      .filter((i) => i.exceptionType == 1)
      .map((i) => i.exceptionDate.split("T")[0]);
    const n2 = templ
      .filter((i) => i.exceptionType == 2)
      .map((i) => i.exceptionDate.split("T")[0]);

    let s = Date.parse(sDay),
      e = Date.parse(eDay);

    while (
      n1.includes(this.getLocalTime(s)) ||
      ([0, 6].includes(new Date(s).getDay()) &&
        !n2.includes(this.getLocalTime(s)))
    ) {
      s += 24 * 60 * 60 * 1000;
    }

    while (
      n1.includes(this.getLocalTime(e)) ||
      ([0, 6].includes(new Date(e).getDay()) &&
        !n2.includes(this.getLocalTime(e)))
    ) {
      e -= 24 * 60 * 60 * 1000;
    }

    if (e < s) {
      return 1;
    }
    var n = 1;

    while (s < e) {
      s += 24 * 60 * 60 * 1000;
      n = n + 1;
      if (
        n1.includes(this.getLocalTime(s)) ||
        ([0, 6].includes(new Date(s).getDay()) &&
          !n2.includes(this.getLocalTime(s)))
      ) {
        n = n - 1;
      }
    }
    return n;
  }),
    (Vue.prototype.getLocalTime = function (t) {
      let date = new Date(t);
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;
      date = year + "-" + month + "-" + day;
      return date;
    }),
    (Vue.prototype.costConvolution = function (arr, row) {
      let sum = 0;
      for (let i = 1, j = arr.length; i < j; i++) {
        const e = row[arr[i]] || 0.0;
        sum += parseFloat(e);
      }
      sum = sum.toFixed(2);
      return sum;
    });
  // Vue.prototype.getPoint = function(x){
  //   let y = String(x).indexOf(".") + 1;
  //   let n  = String(x).length - y;
  //   const m = y > 0 ? 0 : n;
  //   return m
  // };
  (Vue.prototype.getItemSeq = function (array, l, n) {
    if (!array || !array.length) return;
    let level = l || 1;
    let parentLevel = n || 0;
    array.forEach((item, e) => {
      item.seq = !parentLevel ? e + 1 + "" : parentLevel + "." + (e + 1 + "");
      if (item.children && item.children.length) {
        this.getItemSeq(item.children, level + 1, item.seq);
      }
    });
    // console.log(array);
    return array;
  }),
    (Vue.prototype.getPar = function (list, row) {
      const id = row.id || row.parentId;
      if (!list || !id) {
        return "";
      }
      let arr = [];
      let findParent = (data, nodeId, parentId) => {
        for (var i = 0, length = data.length; i < length; i++) {
          let node = data[i];
          let e = node.id || node.value;
          if (e === nodeId) {
            // console.log(node);
            arr.push(node);
            if (nodeId === list[0].id || nodeId === list[0].value) {
              break;
            }
            findParent(list, parentId);
            break;
          } else {
            if (node.children) {
              findParent(node.children, nodeId, e);
            }
            continue;
          }
        }
        return arr;
      };
      return findParent(list, id);
    });

  Vue.prototype.getChildList = function (list, row) {
    const id = row.id || row.parentId;
    if (!list || !id) {
      return "";
    }
    let arr = [];
    let findChild = (data, nodeId, parentId) => {
      for (var i = 0, length = data.length; i < length; i++) {
        let node = data[i];
        if (node.id === nodeId) {
          // console.log(node);
          arr.push(node);
          if (nodeId === list[0].id) {
            break;
          }
          findParent(list, parentId);
          break;
        } else {
          if (node.children) {
            findParent(node.children, nodeId, node.id);
          }
          continue;
        }
      }
      return arr;
    };
    return findChild(list, id);
  };

  Vue.prototype.getAllRow = function (data) {
    let newArr = [];
    let findRow = (arr) => {
      for (let i = 0; i < arr.length; i++) {
        const item = arr[i];
        newArr.push(item);
        if (!!item["children"] && item["children"].length) {
          // console.log(id,newArr,item["children"]);
          findRow(item["children"]);
        }
      }
      return newArr;
    };
    return findRow(data);
  };

  Vue.prototype.getRow = function (arr, id) {
    // console.log(arr);
    // newArr = newArr || []
    let findRow = (arr, id, newArr) => {
      newArr = newArr || [];
      for (let i = 0; i < arr.length; i++) {
        const item = arr[i];
        if (item.id == id) {
          newArr.push(item);
          return newArr;
        } else {
          if (item["children"] && item["children"].length) {
            // console.log(id,newArr,item["children"]);
            findRow(item["children"], id, newArr);
          }
        }
      }
      return newArr;
    };
    return findRow(arr, id);
  };

  Vue.prototype.replaceTabsName = function (e) {
    let tabs = this.$store.getters.getShowingTabInHome;
    console.log(tabs);
    const n = tabs.findIndex(
      (i) =>
        i.objId == this.$store.state.objectId.id &&
        i.objClass == this.$store.state.objectId.classId
    );
    tabs[n].title = e;
    this.$store.commit("replaceShowingTabsInHome", tabs);
    this.$store.commit("setActivedTabInHome", tabs[n].name);
  };
  Vue.prototype.rowDrop = function () {
    this.$nextTick(() => {
      const xTable = this.$refs.xGrid;
      this.sortable2 = Sortable.create(
        xTable.$el.querySelector(".body--wrapper>.vxe-table--body tbody"),
        {
          handle: ".drag-btn",
          onEnd: ({ item, oldIndex }) => {
            const options = { children: "children" };
            const targetTrElem = item;
            const wrapperElem = targetTrElem.parentNode;
            const prevTrElem = targetTrElem.previousElementSibling;
            const tableData = this.gridOptions.data;
            const selfRow = xTable.getRowNode(targetTrElem).item;
            const selfNode = XEUtils.findTree(
              tableData,
              (row) => row === selfRow,
              options
            );
            if (prevTrElem) {
              // 移动到节点
              const prevRow = xTable.getRowNode(prevTrElem).item;
              const prevNode = XEUtils.findTree(
                tableData,
                (row) => row === prevRow,
                options
              );
              if (
                XEUtils.findTree(
                  selfRow[options.children],
                  (row) => prevRow === row,
                  options
                )
              ) {
                // 错误的移动
                const oldTrElem = wrapperElem.children[oldIndex];
                wrapperElem.insertBefore(targetTrElem, oldTrElem);
                return this.$message.error("不允许自己给自己拖动！");
              }
              const currRow = selfNode.items.splice(selfNode.index, 1)[0];
              if (xTable.isTreeExpandByRow(prevRow)) {
                // 移动到当前的子节点
                prevRow[options.children].splice(0, 0, currRow);
              } else {
                // 移动到相邻节点
                prevNode.items.splice(
                  prevNode.index + (selfNode.index < prevNode.index ? 0 : 1),
                  0,
                  currRow
                );
              }
            } else {
              // 移动到第一行
              const currRow = selfNode.items.splice(selfNode.index, 1)[0];
              tableData.unshift(currRow);
            }
            // 如果变动了树层级，需要刷新数据
            this.gridOptions.data = [...tableData];
            console.log(this.gridOptions.data);
            this.drop = true;
          },
        }
      );
    });
  };
};
